import Vue from "vue";
import VueRouter from "vue-router";
import adminRouterList from "./admin";

Vue.use(VueRouter);

const routerList = [
  // 校长首页
  {
    path: "/",
    name: "home",
    component: () => import("@/pages/default/home"),
  },
  // 校长端
  {
    path: "/school-home-page",
    name: "school-home-page",
    // redirect: "/school-home-page/school-index",
    redirect: "/school-home-page/dataBoard",
    component: () => import("@/pages/school-home-content/school-home-page"),
    // component: () => import("@/pages/school-home-content/dataBoard/index.vue"),
    meta: {
      activeMenu: "dataBoard",
    },
    children: [
      //数据看板
      {
        path: "/school-home-page/dataBoard",
        name: "dataBoard",
        component: () =>
          import("@/pages/school-home-content/dataBoard/index.vue"),
        meta: {
          activeMenu: "dataBoard",
        },
      },
      // 账户信息
      {
        path: "/school-home-page/school-index",
        name: "school-index",
        component: () =>
          import("@/pages/school-home-content/account-info/school-index"),
      },
      // 试听管理
      {
        path: "/school-home-page/listen-test-management",
        name: "listen-test-management",
        component: () =>
          import(
            "@/pages/school-home-content/open-class-management/listen-test-management"
          ),
      },
      // 录入公开课试听学员
      {
        path: "/school-home-page/open-entering-student",
        name: "open-entering-student",
        component: () =>
          import(
            "@/pages/school-home-content/students-management/open-entering-student"
          ),
        meta: {
          activeMenu: "listen-test-management",
        },
      },
      // 录入跟班试听学员
      {
        path: "/school-home-page/flow-entering-student",
        name: "flow-entering-student",
        component: () =>
          import(
            "@/pages/school-home-content/students-management/flow-entering-student"
          ),
        meta: {
          activeMenu: "listen-test-management",
        },
      },

      // 公开课班级管理
      {
        path: "/school-home-page/open-class-management",
        name: "open-class-management",
        component: () =>
          import(
            "@/pages/school-home-content/open-class-management/open-class-management"
          ),
      },
      // 单个建公开课班
      {
        path: "/school-home-page/create-open-class",
        name: "create-open-class",
        component: () =>
          import(
            "@/pages/school-home-content/class-management/create-open-class"
          ),
        meta: {
          activeMenu: "open-class-management",
        },
      },
      // 公开课排课
      {
        path: "/school-home-page/open-course-arranging",
        name: "open-course-arranging",
        component: () =>
          import(
            "@/pages/school-home-content/class-management/opencourse-arranging"
          ),
        meta: {
          activeMenu: "open-class-management",
        },
      },
      // 账户列表页面
      {
        path: "/school-home-page/school-user-list",
        name: "school-user-list",
        component: () =>
          import("@/pages/school-home-content/account-info/school-user-list"),
        meta: {
          activeMenu: "permissionsettings",
        },
      },
      // 账户信息
      {
        path: "/school-home-page/school-user-info",
        name: "school-user-info",
        component: () =>
          import("@/pages/school-home-content/account-info/school-user-info"),
        meta: {
          activeMenu: "permissionsettings",
        },
        // meta: {
        //   activeMenu: "school-user-list",
        // },
      },
      // 编辑账户信息
      {
        path: "/school-home-page/school-edit-user-info",
        name: "school-edit-user-info",
        component: () =>
          import(
            "@/pages/school-home-content/account-info/school-edit-user-info"
          ),
        // meta: {
        //   activeMenu: "school-user-list",
        // },
        meta: {
          activeMenu: "permissionsettings",
        },
      },
      // 班级管理
      {
        path: "/school-home-page/class-management",
        name: "class-management",
        component: () =>
          import(
            "@/pages/school-home-content/class-management/class-management"
          ),
      },
      // 班级详情
      {
        path: "/school-home-page/look-class-info",
        name: "look-class-info",
        component: () =>
          import(
            "@/pages/school-home-content/class-management/look-class-info"
          ),
        meta: {
          activeMenu: "class-management",
        },
      },
      // 单个建公开课班
      {
        path: "/school-home-page/create-openclass",
        name: "create-openclass",
        component: () =>
          import(
            "@/pages/school-home-content/class-management/create-open-class"
          ),
        meta: {
          activeMenu: "class-management",
        },
      },

      // 单个建正式课班级
      {
        path: "/school-home-page/create-class",
        name: "create-class",
        component: () =>
          import("@/pages/school-home-content/class-management/create-class"),
        meta: {
          activeMenu: "class-management",
        },
      },

      // 排课
      {
        path: "/school-home-page/course-arranging",
        name: "course-arranging",
        component: () =>
          import(
            "@/pages/school-home-content/class-management/course-arranging"
          ),
        meta: {
          activeMenu: "class-management",
        },
      },

      // 分班
      {
        path: "/school-home-page/divide-class",
        name: "divide-class",
        component: () =>
          import("@/pages/school-home-content/class-management/divide-class"),
        meta: {
          activeMenu: "class-management",
        },
      },

      // 学员管理
      {
        path: "/school-home-page/students-management",
        name: "students-management",
        component: () =>
          import(
            "@/pages/school-home-content/students-management/students-management"
          ),
      },
      // 录入正式学员
      {
        path: "/school-home-page/entering-student",
        name: "entering-student",
        component: () =>
          import(
            "@/pages/school-home-content/students-management/entering-student"
          ),
        meta: {
          activeMenu: "students-management",
        },
      },

      // 录入学员管理
      {
        path: "/school-home-page/input-student-management",
        name: "input-student-management",
        component: () =>
          import(
            "@/pages/school-home-content/students-management/input-student-management"
          ),
        meta: {
          activeMenu: "input-student-management",
        },
      },

      // 邀约查询
      {
        path: "/school-home-page/input-student-search",
        name: "input-student-search",
        component: () =>
          import(
            "@/pages/school-home-content/students-management/input-student-search"
          ),
        meta: {
          activeMenu: "input-student-search",
        },
      },

      // 录入意向学员
      {
        path: "/school-home-page/input-student",
        name: "input-student",
        component: () =>
          import(
            "@/pages/school-home-content/students-management/input-student"
          ),
        meta: {
          activeMenu: "input-student-management",
        },
      },
      //录入试听学员
      {
        path: "/school-home-page/input-auditionstudent",
        name: "input-auditionstudent",
        component: () =>
          import(
            "@/pages/school-home-content/students-management/input-auditionstudent"
          ),
        meta: {
          activeMenu: "auditionstudent",
        },
      },

      //前台新增学员报名
      {
        path: "/school-home-page/addnewstudent",
        name: "addnewstudent",
        component: () =>
          import("@/pages/school-home-content/reception/addnewstudent"),
        meta: {
          activeMenu: "addnewstudent",
        },
      },

      //前台-学员信息管理
      {
        path: "/school-home-page/student-management",
        name: "student-management",
        component: () =>
          import("@/pages/school-home-content/reception/studentmanagement"),
        meta: {
          activeMenu: "student-management",
        },
      },

      //前台-试听管理
      {
        path: "/school-home-page/auditionstudent",
        name: "auditionstudent",
        component: () =>
          import("@/pages/school-home-content/reception/auditionstudent"),
        meta: {
          activeMenu: "auditionstudent",
        },
      },

      //前台-交费报名
      {
        path: "/school-home-page/orderpay",
        name: "orderpay",
        component: () =>
          import("@/pages/school-home-content/reception/orderpay"),
        meta: {
          activeMenu: "orderpay",
        },
      },

      //前台-结转
      {
        path: "/school-home-page/ordercarry",
        name: "ordercarry",
        component: () =>
          import("@/pages/school-home-content/reception/ordercarry"),
        meta: {
          activeMenu: "ordercarry",
        },
      },

      //前台-退费
      {
        path: "/school-home-page/refund",
        name: "refund",
        component: () => import("@/pages/school-home-content/reception/refund"),
        meta: {
          activeMenu: "refund",
        },
      },

      // 班级管理1
      {
        path: "/school-home-page/class-management1",
        name: "class-management1",
        component: () => import("@/pages/class-management1/index.vue"),
        meta: {
          activeMenu: "class-management1",
          keepAlive: false,
          routeKey: ''
        },
      },
      //新建班级

      {
        path: "/school-home-page/class-management1/create-openclass1",
        name: "create-openclass1",
        component: () =>
          import("@/pages/class-management1/create-openclass1.vue"),
        meta: {
          activeMenu: "class-management1",
        },
      },
      //新建班级/分班/排课

      {
        path: "/school-home-page/class-management1/divide-class1",
        name: "divide-class1",
        component: () => import("@/pages/class-management1/divide-class1.vue"),
        meta: {
          activeMenu: "class-management1",
        },
      },
      //新建班级/分班/批量排课

      {
        path: "/school-home-page/class-management1/allDivide-class",
        name: "allDivide-class",
        component: () =>
          import("@/pages/class-management1/allDivide-class.vue"),
        meta: {
          activeMenu: "class-management1",
        },
      },
      // 学员管理
      {
        path: "/school-home-page/class-management1/students-management1",
        name: "students-management1",
        component: () =>
          import("@/pages/class-management1/students-management1.vue"),
        meta: {
          activeMenu: "students-management1",
          keepAlive: false,
          routeKey: '',
        },
      },
      //学生详情
      {
        path: "/school-home-page/finance/studentDetails",
        name: "studentDetails",
        component: () => import("@/pages/finance/studentDetails"),
        meta: {
          activeMenu: "students-management1",
        },
      },

      // 学员管理
      {
        path: "/school-home-page/class-management1/addnewstudent1",
        name: "addnewstudent1",
        component: () => import("@/pages/class-management1/addnewstudent1.vue"),
        meta: {
          activeMenu: "students-management1",
        },
      },
      //教务中心-教学计划
      {
        path: "/school-home-page/class-management1/teachplan1",
        name: "teachplan1",
        component: () => import("@/pages/class-management1/teachplan1.vue"),
        meta: {
          activeMenu: "teachplan1",
        },
      },
      //教务中心-课表
      {
        path: "/school-home-page/class-management1/SchoolCurriculum",
        name: "SchoolCurriculum",
        component: () =>
          import("@/pages/class-management1/SchoolCurriculum.vue"),
        meta: {
          activeMenu: "SchoolCurriculum",
        },
      },

      //教务中心-上课记录
      {
        path: "/school-home-page/class-management1/classRecord",
        name: "classRecord",
        component: () => import("@/pages/class-management1/classRecord.vue"),
        meta: {
          activeMenu: "classRecord",
        },
      },
      {
        path: "/school-home-page/class-management1/newClass",
        name: "newClass",
        component: () => import("@/pages/class-management1/newClass.vue"),
        meta: {
          activeMenu: "classRecord",
        },
      },
      {
        path: "/school-home-page/class-management1/newClassStu",
        name: "newClassStu",
        component: () => import("@/pages/class-management1/newClassStu.vue"),
        meta: {
          activeMenu: "classRecord",
        },
      },

      // 运营招生/基础物料
      {
        path: "/school-home-page/basicMaterial",
        name: "basic-material",
        component: () => import("@/pages/basicMaterial"),
        meta: {
          keepAlive: false,
          activeMenu: "basic-material",
        },
      },
      // 运营招生/基础物料/详情
      {
        path: "/school-home-page/basicMaterial/details",
        name: "basic-material-details",
        component: () => import("@/pages/basicMaterial/details.vue"),
        meta: {
          activeMenu: "basic-material",
        },
      },
      //  运营招生/课程培训
      {
        path: "/school-home-page/coursesTraining",
        name: "courses-training",
        component: () => import("@/pages/coursesTraining"),
        meta: {
          activeMenu: "courses-training",
          keepAlive: false,
        },
      },
      //  培训课程/详情
      {
        path: "/school-home-page/coursesTraining/details",
        name: "courses-training-details",
        component: () => import("@/pages/coursesTraining/details"),
        meta: {
          activeMenu: "courses-training",
        },
      },
      // 运营招生/平台活动
      {
        path: "/school-home-page/platformActivities",
        name: "platform-activities",
        component: () => import("@/pages/platformActivities"),
        meta: {
          activeMenu: "platform-activities",
        },
      },
      // 运营招生/平台活动/最新活动
      {
        path: "/school-home-page/platformActivities/newDetails",
        name: "platform-activities-newDetails",
        component: () => import("@/pages/platformActivities/newDetails.vue"),
        meta: {
          activeMenu: "platform-activities",
        },
      },
      // 运营招生/平台活动/往期活动
      {
        path: "/school-home-page/platformActivities/oldDetails",
        name: "platform-activities-oldDetails",
        component: () => import("@/pages/platformActivities/oldDetails.vue"),
        meta: {
          activeMenu: "platform-activities",
        },
      },

      //教务中心-排课管理
      {
        path: "/school-home-page/teachplan",
        name: "teachplan",
        component: () =>
          import("@/pages/school-home-content/teachplan/teachplan"),
        meta: {
          activeMenu: "teachplan",
        },
      },

      //报表中心-收费报表
      {
        path: "/school-home-page/order-report",
        name: "order-report",
        component: () =>
          import("@/pages/school-home-content/report/order-report"),
        meta: {
          activeMenu: "order-report",
        },
      },
      //报表中心-课消报表
      {
        path: "/school-home-page/attendance-report",
        name: "attendance-report",
        component: () =>
          import("@/pages/school-home-content/report/attendance-report"),
        meta: {
          activeMenu: "attendance-report",
        },
      },

      // 学员详情
      {
        path: "/school-home-page/student-detail",
        name: "student-detail",
        component: () =>
          import(
            "@/pages/school-home-content/students-management/student-detail"
          ),
        meta: {
          activeMenu: "students-management",
        },
      },
      //授课时段
      {
        path: "/school-home-page/teachingperiod",
        name: "teachingperiod",
        component: () =>
          import("@/pages/school-home-content/basic-settings/teachingperiod"),
        meta: {
          activeMenu: "basicsettings",
        },
      },
      //停课日
      {
        path: "/school-home-page/listeningday",
        name: "listeningday",
        component: () =>
          import("@/pages/school-home-content/basic-settings/listeningday"),
        meta: {
          activeMenu: "basicsettings",
        },
      },
      //收款账户
      {
        path: "/school-home-page/account",
        name: "account",
        component: () =>
          import("@/pages/school-home-content/basic-settings/account"),
        meta: {
          activeMenu: "basicsettings",
        },
      },
      //微信服务号
      {
        path: "/school-home-page/vxservice",
        name: "vxservice",
        component: () =>
          import("@/pages/school-home-content/basic-settings/vxservice"),
        meta: {
          activeMenu: "basicsettings",
        },
      },

      //物品
      {
        path: "/school-home-page/article",
        name: "article",
        component: () =>
          import("@/pages/school-home-content/basic-settings/article"),
        meta: {
          activeMenu: "basicsettings",
        },
      },
      //权限管理
      {
        path: "/school-home-page/permissionsettings",
        name: "permissionsettings",
        component: () =>
          import(
            "@/pages/school-home-content/basic-settings/permissionsettings"
          ),
        // meta: {
        //   activeMenu: "permissionsettings",
        // },
      },
      //操作日志
      {
        path: "/school-home-page/operationLog",
        name: "operationLog",
        component: () =>
          import(
            "@/pages/school-home-content/basic-settings/operationLog"
          ),
        // meta: {
        //   activeMenu: "operationLog",
        // },
      },
      //分校设置
      {
        path: "/school-home-page/schoolSys",
        name: "schoolSys",
        component: () =>
          import("@/pages/school-home-content/basic-settings/schoolSys"),
        meta: {
          activeMenu: "permissionsettings",
        },
      },
      //平台
      {
        path: "/school-home-page/platform",
        name: "platform",
        component: () =>
          import("@/pages/school-home-content/basic-settings/platform"),
        meta: {
          activeMenu: "permissionsettings",
        },
      },
      // 基础设置
      {
        path: "/school-home-page/basicsettings",
        name: "basicsettings",
        component: () =>
          import("@/pages/school-home-content/basic-settings/basicsettings"),
      },
      //收支明细
      {
        path: "/school-home-page/finance/expenditureDetails",
        name: "expenditureDetails",
        component: () => import("@/pages/finance/expenditureDetails"),
      },
      // 课消记录
      {
        path: "/school-home-page/finance/courseCancellationRecords",
        name: "courseCancellationRecords",
        component: () => import("@/pages/finance/courseCancellationRecords"),
      },
      //充值管理
      {
        path: "/school-home-page/finance/recharge",
        name: "recharge",
        component: () => import("@/pages/finance/recharge"),
      },
      //财务管理
      {
        path: "/school-home-page/finance/ordermanagement",
        name: "ordermanagement",
        component: () => import("@/pages/finance/ordermanagement"),
      },
      //财务管理-报名续费
      {
        path: "/school-home-page/finance/contracts",
        name: "contracts",
        component: () => import("@/pages/finance/contracts"),
        meta: {
          activeMenu: "ordermanagement",
        },
      },
      //财务管理-退物品
      {
        path: "/school-home-page/finance/returningItems",
        name: "returningItems",
        component: () => import("@/pages/finance/returningItems"),
        meta: {
          activeMenu: "ordermanagement",
        },
      },
      //财务管理-退费用
      {
        path: "/school-home-page/finance/cost",
        name: "cost",
        component: () => import("@/pages/finance/cost"),
        meta: {
          activeMenu: "ordermanagement",
        },
      },
      //财务管理-订单详情
      {
        path: "/school-home-page/finance/ordermanagementDetail",
        name: "ordermanagementDetail",
        component: () => import("@/pages/finance/ordermanagementDetail"),
        meta: {
          activeMenu: "ordermanagement",
        },
      },
      //财务管理-账户充值
      {
        path: "/school-home-page/finance/accountRecharge",
        name: "accountRecharge",
        component: () => import("@/pages/finance/accountRecharge"),
        meta: {
          activeMenu: "ordermanagement",
        },
      },
      //财务管理-账户充值
      {
        path: "/school-home-page/finance/accountRefund",
        name: "accountRefund",
        component: () => import("@/pages/finance/accountRefund"),
        meta: {
          activeMenu: "ordermanagement",
        },
      },
      //
      //财务管理-推课程
      {
        path: "/school-home-page/finance/withdrawalOfCourses",
        name: "withdrawalOfCourses",
        component: () => import("@/pages/finance/withdrawalOfCourses"),
        meta: {
          activeMenu: "ordermanagement",
        },
      },
      //财务管理-转课
      //
      {
        path: "/school-home-page/finance/transferOfCourses",
        name: "transferOfCourses",
        component: () => import("@/pages/finance/transferOfCourses"),
        meta: {
          activeMenu: "ordermanagement",
        },
      },

      // cost

      {
        path: "/school-home-page/basic-settings",
        name: "basic-settings",
        component: () =>
          import("@/pages/school-home-content/basic-settings/basic-settings"),
      },
      //校区课程设置
      {
        path: "/school-home-page/Campuscourses",
        name: "Campuscourses",
        component: () => import("@/pages/school-home-content/Campuscourses"),
        // meta: {
        //   activeMenu: "Campuscourses",
        // },
        meta: {
          activeMenu: "permissionsettings",
        },
      },
      //添加课程
      {
        path: "/school-home-page/addCourse",
        name: "addCourse",
        component: () =>
          import("@/pages/school-home-content/Campuscourses/addCourse.vue"),
        // meta: {
        //   activeMenu: "Campuscourses",
        // },
        meta: {
          activeMenu: "permissionsettings",
        },
      },
      //修改课程
      {
        path: "/school-home-page/editCourse",
        name: "editCourse",
        component: () =>
          import("@/pages/school-home-content/Campuscourses/editCourse.vue"),
        // meta: {
        //   activeMenu: "Campuscourses",
        // },
        meta: {
          activeMenu: "permissionsettings",
        },
      },
      //讲次管理
      {
        path: "/school-home-page/resourcesmaterial",
        name: "resourcesmaterial",
        component: () =>
          import(
            "@/pages/school-home-content/Campuscourses/resourcesmaterial.vue"
          ),
        // meta: {
        //   activeMenu: "Campuscourses",
        // },
        meta: {
          activeMenu: "permissionsettings",
        },
      },
      //添加图层
      {
        path: "/school-home-page/addAlbum",
        name: "addAlbum",
        component: () =>
          import("@/pages/school-home-content/Campuscourses/addAlbum.vue"),
        // meta: {
        //   activeMenu: "Campuscourses",
        // },
        meta: {
          activeMenu: "permissionsettings",
        },
      },
      //教学资料

      {
        path: "/school-home-page/tchDate",
        name: "tchDate",
        component: () =>
          import("@/pages/school-home-content/Campuscourses/tchDate.vue"),
        // meta: {
        //   activeMenu: "Campuscourses",
        // },
        meta: {
          activeMenu: "permissionsettings",
        },
      },
      //校区课程设置
      {
        path: "/school-home-page/owncourse",
        name: "owncourse",
        component: () =>
          import("@/pages/school-home-content/owncourse/owncourse"),
        meta: {
          activeMenu: "owncourse",
        },
      },

      {
        path: "/school-home-page/create-owncourse",
        name: "create-owncourse",
        component: () =>
          import("@/pages/school-home-content/owncourse/create-owncourse"),
        meta: {
          activeMenu: "owncourse",
        },
      },
      //编辑校区课程
      {
        path: "/school-home-page/edit-owncourse",
        name: "edit-owncourse",
        component: () =>
          import("@/pages/school-home-content/owncourse/edit-owncourse"),
        meta: {
          activeMenu: "owncourse",
        },
      },
      //查看校区课程
      {
        path: "/school-home-page/preview-owncourse",
        name: "preview-owncourse",
        component: () =>
          import("@/pages/school-home-content/owncourse/preview-owncourse"),
        meta: {
          activeMenu: "owncourse",
        },
      },
      //预览校区课程
      {
        path: "/school-home-page/look-owncourse",
        name: "look-owncourse",
        component: () =>
          import("@/pages/school-home-content/owncourse/look-owncourse"),
        meta: {
          activeMenu: "owncourse",
        },
      },

      //收款账户设置
      {
        path: "/school-home-page/payaccount",
        name: "payaccount",
        component: () =>
          import("@/pages/school-home-content/basic-settings/payaccount"),
      },
      //超管基础设置
      {
        path: "/school-home-page/admin-basic-settings",
        name: "admin-basic-settings",
        component: () =>
          import(
            "@/pages/school-home-content/basic-settings/admin-basic-settings"
          ),
      },

      //授权设置
      {
        path: "/school-home-page/admin-authorize-settings",
        name: "admin-authorize-settings",
        component: () =>
          import(
            "@/pages/school-home-content/basic-settings/admin-authorize-settings"
          ),
      },
      // 考勤查询
      {
        path: "/school-home-page/check-work-attendance",
        name: "check-work-attendance",
        component: () =>
          import(
            "@/pages/school-home-content/check-work-attendance/check-work-attendance"
          ),
      },
      // 自有课程管理
      {
        path: "/school-home-page/own-class-management",
        name: "own-class-management",
        component: () =>
          import(
            "@/pages/school-home-content/own-class-management/own-class-management"
          ),
      },
      // 新建课程体系
      {
        path: "/school-home-page/create-curriculum-system",
        name: "create-curriculum-system",
        component: () =>
          import(
            "@/pages/school-home-content/own-class-management/create-curriculum-system"
          ),
        meta: {
          activeMenu: "own-class-management",
        },
      },
      // 编辑课程体系
      {
        path: "/school-home-page/edit-curriculum-system",
        name: "edit-curriculum-system",
        component: () =>
          import(
            "@/pages/school-home-content/own-class-management/edit-curriculum-system"
          ),
        meta: {
          activeMenu: "own-class-management",
        },
      },
      // 商品列表
      {
        path: "/school-home-page/goods-list",
        name: "goods-list",
        component: () =>
          import("@/pages/school-home-content/goods-list/goods-list"),
      },
      // 编辑商品
      {
        path: "/school-home-page/edit-goods",
        name: "edit-goods",
        component: () =>
          import("@/pages/school-home-content/goods-list/edit-goods"),
        meta: {
          activeMenu: "admin-basic-settings",
        },
      },
      //添加商品
      {
        path: "/school-home-page/add-goods",
        name: "add-goods",
        component: () =>
          import("@/pages/school-home-content/goods-list/add-goods"),
        meta: {
          activeMenu: "goods-list",
        },
      },

      //校区课程
      {
        path: "/school-home-page/course-list",
        name: "course-list",
        component: () =>
          import("@/pages/school-home-content/courselist/course-list"),
      },

      //培训中心
      {
        path: "/school-home-page/training-course",
        name: "training-course",
        component: () =>
          import("@/pages/school-home-content/training-course/training-course"),
      },
      //视频列表
      {
        path: "/school-home-page/traininglist",
        name: "traininglist",
        component: () =>
          import("@/pages/school-home-content/training-course/traininglist"),
      },

      //校区角色权限
      {
        path: "/school-home-page/roleauth",
        name: "roleauth",
        component: () => import("@/pages/school-home-content/rbac/roleauth"),
        meta: {
          activeMenu: "permissionsettings",
        },
      },

      //课程授权
      {
        path: "/school-home-page/owncourse-list",
        name: "owncourse-list",
        component: () =>
          import("@/pages/school-home-content/courselist/owncourse-list"),
      },

      // 财务列表
      {
        path: "/school-home-page/finance-list",
        name: "finance-list",
        component: () =>
          import("@/pages/school-home-content/finance-list/finance-list"),
      },
      // 财务退款列表
      {
        path: "/school-home-page/refund-list",
        name: "refund-list",
        component: () =>
          import("@/pages/school-home-content/finance-list/refund-list"),
      },
      // 财务退款详情
      {
        path: "/school-home-page/refund-content",
        name: "refund-content",
        component: () =>
          import("@/pages/school-home-content/finance-list/refund-content"),
      },
      // 财务订单详情
      {
        path: "/school-home-page/finance-content",
        name: "finance-content",
        component: () =>
          import("@/pages/school-home-content/finance-list/finance-content"),
      },

      //校区装修
      {
        path: "/school-home-page/home-carousel",
        name: "home-carousel",
        component: () =>
          import("@/pages/school-home-content/homeset/home-carousel"),
        // meta: {
        //   activeMenu: "home-carousel",
        // },
        meta: {
          activeMenu: "basicsettings",
        },
      },

      //社区配置
      {
        path: "/school-home-page/community-carousel",
        name: "community-carousel",
        component: () =>
          import("@/pages/school-home-content/communityset/community-carousel"),
        // meta: {
        //   activeMenu: "community-carousel",
        //   name: "community-carousel",
        // },
        meta: {
          activeMenu: "basicsettings",
        },
      },
      // 用户自定义基础设置
      {
        path: "/school-home-page/basePersonalizedSetting",
        name: 'basePersonalizedSetting',
        component: () => import("@/pages/school-home-content/basePersonalizedSetting/index.vue"),
        meta: {
          name: '基础设置',
          activeMenu: 'basicsettings'
        }
      },
      // 新增学习报告设置
      {
        path: "/school-home-page/baseLearningReportSetting",
        name: 'baseLearningReportSetting',
        component: () => import("@/pages/school-home-content/baseLearningReportSetting/index.vue"),
        meta: {
          name: '基础设置',
          activeMenu: 'basicsettings'
        }
      },
      // 移动点名规则
      {
        path: "/school-home-page/namingRuleSetting",
        name: 'namingRuleSetting',
        component: () => import("@/pages/school-home-content/namingRuleSetting/index.vue"),
        meta: {
          name: '基础设置',
          activeMenu: 'basicsettings'
        }
      },
      // 星币管理
      {
        path: "/school-home-page/starCoinManagement",
        name: "starCoinManagement",
        component: () =>
          import("@/pages/school-home-content/starCoinManagement/index.vue"),
        meta: {
          name: '星币管理',
          activeMenu: "basicsettings",
        },
        children: [
          { // 订单管理=》兑换记录
            path: "/school-home-page/starCoinManagement/orderManagement",
            name: "orderManagement",
            component: () =>
              import("@/pages/school-home-content/starCoinManagement/orderManagement.vue"),
            meta: {
              name: '兑换记录',
              activeMenu: "orderManagement",
            },
            children: [
              { // 订单详情
                path: "orderDetail",
                name: "orderDetail",
                component: () =>
                  import("@/pages/school-home-content/starCoinManagement/orderDetail.vue"),
                meta: {
                  name: '记录详情',
                  activeMenu: "orderDetail",
                },
              },
            ]
          },
          { // 商品管理
            path: "/school-home-page/starCoinManagement/goodsManagement",
            name: "goodsManagement",
            component: () =>
              import("@/pages/school-home-content/starCoinManagement/goodsManagement.vue"),
            meta: {
              name: '商品管理',
              activeMenu: "goodsManagement",
            },
            children: [
              { // 订单详情
                path: "goodsDetail",
                name: "goodsDetail",
                component: () =>
                  import("@/pages/school-home-content/starCoinManagement/goodsDetail.vue"),
                meta: {
                  name: '商品详情',
                  activeMenu: "goodsDetail",
                },
              },
            ]
          },
          { // 星币明细
            path: "/school-home-page/starCoinManagement/starCoinDetail",
            name: "starCoinDetail",
            component: () =>
              import("@/pages/school-home-content/starCoinManagement/starCoinDetail.vue"),
            meta: {
              name: '星币明细',
              activeMenu: "starCoinDetail",
            },
          },


          { // 星币排行
            path: "/school-home-page/starCoinManagement/starCoinRanking",
            name: "starCoinRanking",
            component: () =>
              import("@/pages/school-home-content/starCoinManagement/starCoinRanking.vue"),
            meta: {
              name: '星币排行',
              activeMenu: "starCoinRanking",
            },
          },
          { // 规则设置
            path: "/school-home-page/starCoinManagement/rulesSetting",
            name: "rulesSetting",
            component: () =>
              import("@/pages/school-home-content/starCoinManagement/rulesSetting.vue"),
            meta: {
              name: '规则设置',
              activeMenu: "rulesSetting",
            },
          },
        ]
      }
    ],
  },

  //我的教室-教师
  {
    path: "/code-classroom",
    name: "code-classroom",
    redirect: "/code-classroom/classroom-index",
    component: () => import("@/pages/code-classroom/classroom-homepage/index"),
    children: [
      // 教室首页
      {
        path: "/code-classroom/classroom-index",
        name: "classroomIndex",
        component: () =>
          import(
            "@/pages/code-classroom/classroom-homepage/classroom-home/classroom-index"
          ),
        meta: {
          activeMenu: "classroomIndex",
          name: "classroomIndex",
          keepAlive: false,
        },
      },

      //班级管理-教师
      // {
      //   path: "/code-classroom/classlist_index_teacher",
      //   name: "classlistIndexTeacher",
      //   component: () => import("@/pages/code-classroom/classroom-management/teacher/classlist-index-teacher"),
      //   meta: {
      //     activeMenu: "classlistIndexTeacher",
      //     // keepAlive: true
      //   },

      // },
      //班级管理-详情-教师
      {
        path: "/code-classroom/classlist_desc_teacher",
        name: "classlistDescTeacher",
        component: () =>
          import(
            "@/pages/code-classroom/classroom-management/teacher/classlist-desc-teacher"
          ),
        meta: {
          activeMenu: "myClass",
          keepAlive: false,
        },
      },

      //我的课表 不用了
      // {
      //   path: "/code-classroom/mySchedule",
      //   name: "mySchedule",
      //   component: () => import("@/pages/mySchedule/index.vue"),
      //   meta: {
      //     activeMenu: "mySchedule",
      //   },
      // },
      {
        path: "/code-classroom/classroomDetails",
        name: "classroomDetails",
        component: () =>
          import(
            "@/pages/code-classroom/classroom-homepage/classroom-home/classroomDetails.vue"
          ),
        meta: {
          activeMenu: "classroomIndex",
        },
      },
      //我的班级
      {
        path: "/code-classroom/myClass",
        name: "myClass",
        component: () => import("@/pages/myClass/index.vue"),
        meta: {
          activeMenu: "myClass",
          keepAlive: true,
        },
      },
      //作品点评
      {
        path: "/code-classroom/works",
        name: "works",
        component: () => import("@/pages/works/index.vue"),
        meta: {
          activeMenu: "works",
          keepAlive: true,
        },
      },
      {
        path: "/code-classroom/worksDetails",
        name: "worksDetails",
        component: () => import("@/pages/works/worksDetails.vue"),
        meta: {
          activeMenu: "works",
        },
      },

      //作品管理-学生作品
      {
        path: "/code-classroom/classlist_works_stu",
        name: "classlistWorksStu",
        meta: {
          activeMenu: "classlistWorksStu",
          keepAlive: true,
        },
        component: () =>
          import(
            "@/pages/code-classroom/classroom-management/teacher/classlist-works-stu"
          ),
      },
      //作品管理-我的作品
      {
        path: "/code-classroom/classlist_works",
        name: "classlistWorks",
        component: () =>
          import(
            "@/pages/code-classroom/classroom-management/teacher/classlist-works"
          ),
        meta: {
          activeMenu: "classlistWorks",
          keepAlive: true,
        },
      },
      // 师资培训
      {
        path: "/code-classroom/training-course",
        name: "trainingForTeachers",
        component: () => import("@/pages/trainingForTeachers"),
        meta: {
          activeMenu: "trainingForTeachers",
          keepAlive: true,
        },
      },
      {
        path: "/code-classroom/training-course/details",
        name: "trainingForTeachersDetails",
        component: () => import("@/pages/trainingForTeachers/details.vue"),
        meta: {
          activeMenu: "trainingForTeachers",
        },
      },
      // 教研培训
      {
        path: "/code-classroom/activities",
        name: "teachingAndResearchTraining",
        component: () => import("@/pages/teachingAndResearchTraining"),
        meta: {
          activeMenu: "teachingAndResearchTraining",
          keepAlive: true,
        },
      },
      // 教研培训/最新活动详情
      {
        path: "/teachingAndResearchTraining/newDetails",
        name: "teachingAndResearchTrainingNewDetails",
        component: () =>
          import("@/pages/teachingAndResearchTraining/newDetails.vue"),
        meta: {
          activeMenu: "teachingAndResearchTraining",
        },
      },
      // 教研培训/课程回顾
      {
        path: "/teachingAndResearchTraining/oldDetails",
        name: "teachingAndResearchTrainingOldDetails",
        component: () =>
          import("@/pages/teachingAndResearchTraining/oldDetails.vue"),
        meta: {
          activeMenu: "teachingAndResearchTraining",
        },
      },

      {
        path: "/code-classroom/prepare-lessons",
        name: "prepare-lessons",
        component: () => import("@/pages/prepare-lessons"),
        meta: {
          activeMenu: "prepare-lessons",
          keepAlive: true,
        },
      },

      {
        path: "/code-classroom/curriculum-detail",
        name: "curriculum-detail",
        component: () =>
          import("@/pages/prepare-lessons/components/curriculum-detail"),
        meta: {
          activeMenu: "prepare-lessons",
          keepAlive: true,
        },
      },

      {
        path: "/code-classroom/prepare-lessons/subject-data",
        name: "subject-data",
        component: () => import("@/pages/prepare-lessons/subject-data"),
      },
      {
        path: "/code-classroom/prepare-lessons/prepare",
        name: "prepare",
        redirect: "/code-classroom/prepare-lessons/prepare/ppt",
        component: () => import("@/pages/prepare-lessons/prepare-lessons"),

        children: [
          {
            path: "/code-classroom/prepare-lessons/prepare/ppt",
            name: "prepare-ppt",
            component: () =>
              import("@/pages/prepare-lessons/components/prepare-ppt"),
          },
          {
            path: "/code-classroom/prepare-lessons/prepare/pdf",
            name: "prepare-pdf",
            component: () =>
              import("@/pages/prepare-lessons/components/prepare-pdf"),
          },
        ],
      },

      {
        path: "/code-classroom/prepare-lessons/sign-in",
        name: "sign-in",
        component: () => import("@/pages/prepare-lessons/sign-in"),
        meta: {
          activeMenu: "prepare-lessons",
        },
      },

      //授课中心
      {
        path: "/code-classroom/teach-lessons",
        name: "teachLessons",
        redirect: "/code-classroom/teach-lessons/lessons/ppt",
        component: () => import("@/pages/teach-lessons/index"),
        children: [
          {
            path: "/code-classroom/teach-lessons/lessons/ppt",
            name: "teach-ppt",
            component: () =>
              import("@/pages/teach-lessons/components/teach-ppt"),
            meta: {
              // activeMenu: "classlistIndexTeacher",
            },
          },
          {
            path: "/code-classroom/teach-lessons/lessons/pdf",
            name: "teach-pdf",
            component: () =>
              import("@/pages/teach-lessons/components/teach-pdf"),
            meta: {
              // activeMenu: "classlistIndexTeacher",
            },
          },
          {
            path: "/code-classroom/teach-lessons/lessons/sign",
            name: "teach-sign",
            component: () => import("@/pages/teach-lessons/components/sign-in"),
            meta: {
              // activeMenu: "classlistIndexTeacher",
            },
          },
        ],
      },
    ],
  },

  //下载中心
  {
    path: "/download",
    name: "download",
    component: () => import("@/pages/download/index"),
  },

  //测评中心-教师
  {
    path: "/exam/index",
    name: "exam",
    component: () => import("@/pages/exam/index"),

    children: [
      {
        path: "/exam/exam-index",
        name: "exam-index",
        component: () => import("@/pages/exam/components/exam-index"),
        meta: {
          activeMenu: "exam-index",
        },
      },
      {
        path: "/exam/own-question",
        name: "own-question",
        component: () => import("@/pages/exam/components/own-question"),
        meta: {
          activeMenu: "own-question",
          keepAlive: true,
        },
      },
      {
        path: "/exam/add-question",
        name: "add-question",
        component: () => import("@/pages/exam/components/add-question"),
        meta: {
          activeMenu: "own-question",
        },
      },
      {
        path: "/exam/questionlist",
        name: "questionlist",
        component: () => import("@/pages/exam/components/questionlist"),
        meta: {
          activeMenu: "own-question",
        },
      },
      {
        path: "/exam/questionlist1",
        name: "questionlist1",
        component: () => import("@/pages/exam/components/questionlist1"),
        meta: {
          activeMenu: "own-question",
        },
      },

      {
        path: "/exam/platform-questionlist",
        name: "platform-questionlist",
        component: () =>
          import("@/pages/exam/components/platform-questionlist"),
        meta: {
          activeMenu: "platform-question",
        },
      },

      {
        path: "/exam/platform-questionlist1",
        name: "platform-questionlist1",
        component: () =>
          import("@/pages/exam/components/platform-questionlist1"),
        meta: {
          activeMenu: "platform-question",
        },
      },

      {
        path: "/exam/practice",
        name: "practice",
        component: () => import("@/pages/exam/components/practice"),
        meta: {
          activeMenu: "own-question",
        },
      },
      {
        path: "/exam/sequence",
        name: "sequence",
        component: () => import("@/pages/exam/components/sequence"),
        meta: {
          activeMenu: "own-question",
        },
      },
      {
        path: "/exam/create-exam",
        name: "create-exam",
        component: () => import("@/pages/exam/components/create-exam"),
        meta: {
          activeMenu: "exam-management",
        },
      },

      {
        path: "/exam/create-paper",
        name: "create-paper",
        component: () => import("@/pages/exam/components/create-paper"),
        meta: {
          activeMenu: "paper-management",
        },
      },
      {
        path: "/paper/edit-questions",
        name: "edit-questions",
        component: () => import("@/pages/exam/components/edit-questions"),
        meta: {
          activeMenu: "paper-management",
        },
      },
      {
        path: "/paper/edit-exam",
        name: "edit-exam",
        component: () => import("@/pages/exam/components/edit-exam"),
        meta: {
          activeMenu: "exam-management",
        },
      },

      {
        path: "/paper/start-exam",
        name: "start-exam",
        component: () => import("@/pages/exam/components/start-exam"),
        meta: {
          activeMenu: "paper-management",
        },
      },

      {
        path: "/exam/practice-management",
        name: "practice-management",
        component: () => import("@/pages/exam/components/practice-management"),
        meta: {
          activeMenu: "practice-management",
          keepAlive: true,
        },
      },
      {
        path: "/exam/create-practice",
        name: "create-practice",
        component: () => import("@/pages/exam/components/create-practice"),
        meta: {
          activeMenu: "practice-management",
        },
      },
      {
        path: "/exam/edit-practice",
        name: "edit-practice",
        component: () => import("@/pages/exam/components/edit-practice"),
        meta: {
          activeMenu: "practice-management",
        },
      },

      {
        path: "/exam/platform-question",
        name: "platform-question",
        component: () => import("@/pages/exam/components/platform-question"),
        meta: {
          activeMenu: "platform-question",
          keepAlive: true,
        },
      },
      {
        path: "/exam/exam-management",
        name: "exam-management",
        component: () => import("@/pages/exam/components/exam-management"),
        meta: {
          activeMenu: "exam-management",
        },
      },

      {
        path: "/exam/edit-examstu",
        name: "edit-examstu",
        component: () => import("@/pages/exam/components/edit-examstu"),
        meta: {
          activeMenu: "exam-management",
        },
      },

      {
        path: "/exam/edit-practicestu",
        name: "edit-practicestu",
        component: () => import("@/pages/exam/components/edit-practicestu"),
        meta: {
          activeMenu: "practice-management",
        },
      },

      {
        path: "/exam/exam-result",
        name: "exam-result",
        component: () => import("@/pages/exam/components/exam-result"),
        meta: {
          activeMenu: "exam-management",
        },
      },

      {
        path: "/exam/practice-result",
        name: "practice-result",
        component: () => import("@/pages/exam/components/practice-result"),
        meta: {
          activeMenu: "practice-management",
        },
      },
      {
        path: "/exam/correct-practice1",
        name: "correct-practice1",
        component: () => import("@/pages/exam/components/correct-practice1"),
        meta: {
          activeMenu: "practice-management",
        },
      },

      {
        path: "/exam/paper-management",
        name: "paper-management",
        component: () => import("@/pages/exam/components/paper-management"),
        meta: {
          activeMenu: "paper-management",
        },
      },
      {
        path: "/exam/offline-exam",
        name: "offline-exam",
        component: () => import("@/pages/exam/components/offline-exam"),
        meta: {
          activeMenu: "paper-management",
        },
      },
    ],
  },

  //测评中心-学生
  {
    path: "/exam-stu/index",
    name: "exam-stu",
    component: () => import("@/pages/exam-stu/index"),
    children: [
      {
        path: "/exam-stu/examstu-index",
        name: "examstu-index",
        component: () => import("@/pages/exam-stu/components/examstu-index"),
        meta: {
          activeMenu: "examstu-index",
        },
      },
      {
        path: "/exam-stu/exam-list",
        name: "exam-list",
        component: () => import("@/pages/exam-stu/components/exam-list"),
        meta: {
          activeMenu: "exam-list",
        },
      },
      {
        path: "/exam-stu/score-detail",
        name: "score-detail",
        component: () => import("@/pages/exam-stu/components/score-detail"),
      },
      {
        path: "/exam-stu/question-book",
        name: "question-book",
        component: () => import("@/pages/exam-stu/components/question-book"),
        meta: {
          activeMenu: "question-book",
        },
      },
      {
        path: "/exam-stu/practice-record1",
        name: "practice-record1",
        component: () => import("@/pages/exam-stu/components/practice-record1"),
      },

      {
        path: "/exam-stu/exam-offlist",
        name: "exam-offlist",
        component: () => import("@/pages/exam-stu/components/exam-offlist"),
        meta: {
          activeMenu: "exam-offlist",
        },
      },
      {
        path: "/exam-stu/practice-list",
        name: "practice-list",
        component: () => import("@/pages/exam-stu/components/practice-list"),
        meta: {
          activeMenu: "practice-list",
        },
      },
      {
        path: "/exam-stu/practice-offlist",
        name: "practice-offlist",
        component: () => import("@/pages/exam-stu/components/practice-offlist"),
        meta: {
          activeMenu: "practice-offlist",
        },
      },
    ],
  },

  //我的教室-学生
  {
    path: "/code-classroom-stu",
    name: "code-classroom-stu",
    redirect: "/code-classroom/classroom-index-stu",
    component: () =>
      import("@/pages/code-classroom/classroom-homepage/index-stu"),
    children: [
      // 教室首页-学生
      {
        path: "/code-classroom/classroom-index-stu",
        name: "classroomIndexStu",
        component: () =>
          import(
            "@/pages/code-classroom/classroom-homepage/classroom-home/classroom-index-stu"
          ),
      },
      //我的班级-学生
      {
        path: "/code-classroom/classlist_index_stu",
        name: "classlistIndexStu",
        component: () =>
          import(
            "@/pages/code-classroom/classroom-management/student/classlist-index-stu"
          ),
        meta: {
          activeMenu: "classlistIndexStu",
          keepAlive: true,
        },
      },
      //我的班级1-学生
      {
        path: "/code-classroom/classlist_index_stu1",
        name: "classlistIndexStu1",
        component: () =>
          import(
            "@/pages/code-classroom/classroom-management/student/classlist-index-stu1"
          ),
        meta: {
          activeMenu: "classlistIndexStu1",
          keepAlive: true,
        },
      },
      // 我的班级1-学生 - 查看更多
      {
        path: "/code-classroom/classlist_index_stu1_more",
        name: "classlistIndexStu1More",
        component: () =>
          import(
            "@/pages/code-classroom/classroom-management/student/classlist-index-stu1-more"
          ),
        meta: {
          activeMenu: "classlistIndexStu1More",
          keepAlive: true,
        },
      },

      {
        path: "/code-classroom/stuDetails1",
        name: "stuDetails1",
        component: () =>
          import(
            "@/pages/code-classroom/classroom-management/student/stuDetails1"
          ),
        meta: {
          activeMenu: "classlistIndexStu1",
        },
      },
      {
        path: "/code-classroom/stuDetails2",
        name: "stuDetails2",
        component: () =>
          import(
            "@/pages/code-classroom/classroom-management/student/stuDetails2"
          ),
        meta: {
          activeMenu: "classIndexSstu",
        },
      },
      {
        path: "/code-classroom/class_index_stu",
        name: "classIndexSstu",
        component: () =>
          import(
            "@/pages/code-classroom/classroom-management/student/class_index_stu"
          ),
        meta: {
          activeMenu: "classIndexSstu",
          keepAlive: true,
        },
      },
      //班级管理-详情-学生
      {
        path: "/code-classroom/classlist_desc_stu",
        name: "classlistDescStu",
        component: () =>
          import(
            "@/pages/code-classroom/classroom-management/student/classlist-desc-stu"
          ),
        meta: {
          activeMenu: "classIndexSstu",
        },
      },
      // { 不用了
      //   path: "/code-classroom/stuDetails",
      //   name: "stuDetails",
      //   component: () =>
      //     import(
      //       "@/pages/code-classroom/classroom-management/student/stuDetails"
      //     ),
      //   meta: {
      //     activeMenu: "classlistIndexStu",
      //   },
      // },
      //作品管理-学生作品
      {
        path: "/code-classroom/classlist_works_student",
        name: "classlistWorksStudent",
        component: () =>
          import(
            "@/pages/code-classroom/classroom-management/student/classlist-works-student"
          ),
      },
      //作品管理-自由创作
      {
        path: "/code-classroom/classlist-free-works",
        name: "freeCreation",
        component: () =>
          import(
            "@/pages/code-classroom/classroom-management/student/classlist-free-works"
          ),
      },
      //作品管理-课堂作品
      {
        path: "/code-classroom/classlist_stu_works",
        name: "classlistStuWorks",
        component: () =>
          import(
            "@/pages/code-classroom/classroom-management/student/classlist-stu-works"
          ),
      },
      //学生端星币中心
      {
        path: "/code-classroom/stuStarCoinCenter",
        name: "stuStarCoinCenter",
        component: () => import("@/pages/code-classroom/stuStarCoinCenter"),
        meta: {
          activeMenu: "stuStarCoinCenter",
          keepAlive: true,
        },
      },
      //学生端星币排行
      {
        path: "/code-classroom/stuStarCoinRank",
        name: "stuStarCoinRank",
        component: () => import("@/pages/code-classroom/classroom-management/student/stuStarCoinRank"),
        meta: {
          activeMenu: "stuStarCoinRank",
          keepAlive: true,
        },
      },

      // 打字星球
      {
        path: '/code-classroom/typing-planet',
        name: 'TypingPlanet',
        component: () => import('@/pages/code-classroom/typingPlanet'),
        meta: {
          title: '打字星球',
          activeMenu: 'typingPlanet',
          requireAuth: true,
          keepAlive: true
        }
      },

      {
        path: '/code-classroom/typing-planet-learn',
        name: 'TypingPlanetLearn',
        component: () => import('@/pages/code-classroom/typingPlanet/intro/learn.vue'),
        meta: {
          title: '基础指法学习',
          activeMenu: 'typingPlanet',
          requireAuth: true
        }
      },
      {
        path: '/code-classroom/typing-planet-review',
        name: 'TypingPlanetReview',
        component: () => import('@/pages/code-classroom/typingPlanet/intro/review.vue'),
        meta: {
          title: '基础指法复习',
          activeMenu: 'typingPlanet',
          requireAuth: true
        }
      },
      {
        path: '/code-classroom/typing-planet-practice',
        name: 'TypingPlanetPractice',
        component: () => import('@/pages/code-classroom/typingPlanet/intro/practice.vue'),
        meta: {
          title: '基础指法练习',
          activeMenu: 'typingPlanet',
          requireAuth: true
        }
      },
      {
        path: '/code-classroom/typing-planet-race',
        name: 'TypingPlanetRace',
        component: () => import('@/pages/code-classroom/typingPlanet/intro/race.vue'),
        meta: {
          title: '基础指法游戏',
          activeMenu: 'typingPlanet',
          requireAuth: true
        }
      },
      {
        path: '/code-classroom/typing-planet-meteor',
        name: 'TypingPlanetMeteor',
        component: () => import('@/pages/code-classroom/typingPlanet/intro/meteor.vue'),
        meta: {
          title: '陨石大战',
          activeMenu: 'typingPlanet',
          requireAuth: true
        }
      },
      {
        path: '/code-classroom/typing-planet-balloon',
        name: 'TypingPlanetBalloon',
        component: () => import('@/pages/code-classroom/typingPlanet/intro/balloon.vue'),
        meta: {
          title: '气球大战',
          activeMenu: 'typingPlanet',
          requireAuth: true
        }
      },
      {
        path: '/code-classroom/typing-planet-puzzle',
        name: 'TypingPlanetMouse',
        component: () => import('@/pages/code-classroom/typingPlanet/intro/puzzlegame.vue'),
        meta: {
          title: '鼠标拖动练习',
          activeMenu: 'typingPlanet',
          requireAuth: true
        }
      },
      {
        path: '/code-classroom/typing-planet-drag',
        name: 'TypingPlanetDrag',
        component: () => import('@/pages/code-classroom/typingPlanet/intro/puzzledrag.vue'),
        meta: {
          title: '图片拖动练习',
          activeMenu: 'typingPlanet',
          requireAuth: true
        }
      },
      {
        path: '/code-classroom/typing-planet-piece',
        name: 'TypingPlanetPiece',
        component: () => import('@/pages/code-classroom/typingPlanet/intro/puzzlepiece.vue'),
        meta: {
          title: '碎片拼接练习',
          activeMenu: 'typingPlanet',
          requireAuth: true
        }
      },
      {
        path: '/code-classroom/typing-planet-keywords',
        name: 'TypingPlanetKeywords',
        component: () => import('@/pages/code-classroom/typingPlanet/intro/keywords.vue'),
        meta: {
          title: '关键字练习',
          activeMenu: 'typingPlanet',
          requireAuth: true
        }
      },
      {
        path: '/code-classroom/typing-planet-pinyin',
        name: 'TypingPlanetPinyin',
        component: () => import('@/pages/code-classroom/typingPlanet/intro/pinyin.vue'),
        meta: {
          title: '拼音练习',
          activeMenu: 'typingPlanet',
          requireAuth: true
        }
      },
      {
        path: '/code-classroom/typing-planet-words',
        name: 'TypingPlanetWords',
        component: () => import('@/pages/code-classroom/typingPlanet/intro/words.vue'),
        meta: {
          title: '词语与短句',
          activeMenu: 'typingPlanet',
          requireAuth: true
        }
      },


      {
        path: '/code-classroom/typing-planet-basic-1',
        name: 'TypingPlanetBasic1',
        component: () => import('@/pages/code-classroom/typingPlanet/basic-1.vue'),
        meta: {
          title: '关键字练习',
          activeMenu: 'typingPlanet',
          requireAuth: true
        }
      },

      {
        path: '/code-classroom/typing-planet-basic-2',
        name: 'TypingPlanetBasic2',
        component: () => import('@/pages/code-classroom/typingPlanet/basic-2.vue'),
        meta: {
          title: '关键字练习',
          activeMenu: 'typingPlanet',
          requireAuth: true
        }
      },

      {
        path: '/code-classroom/typing-planet-basic-3',
        name: 'TypingPlanetBasic3',
        component: () => import('@/pages/code-classroom/typingPlanet/basic-3.vue'),
        meta: {
          title: '关键字练习',
          activeMenu: 'typingPlanet',
          requireAuth: true
        }
      },

    ],
  },

  //编程社区
  {
    path: "/community",
    name: "community",
    redirect: "/community/home",
    component: () => import("@/pages/community/index"),
    children: [
      //社区Header
      {
        path: "/community/header",
        name: "community-header",
        component: () => import("@/pages/community/components/header"),
      },
      //社区Home
      {
        path: "/community/home",
        name: "community-home",
        component: () => import("@/pages/community/components/home"),
        meta: {
          keepAlive: true,
        },
      },
      //社区Footer
      {
        path: "/community/footer",
        name: "community-footer",
        component: () => import("@/pages/community/components/footer"),
      },
      //社区发现页
      {
        path: "/community/explore",
        name: "community-explore",
        component: () => import("@/pages/community/components/explore"),
        meta: {
          keepAlive: true,
        },
      },
      //共享社区
      {
        path: "/community/shared",
        name: "community-shared",
        component: () => import("@/pages/community/components/shared"),
        meta: {
          keepAlive: true,
        },
      },
      //社区评论页面
      {
        path: "/community/comment",
        name: "community-comment",
        component: () => import("@/pages/community/components/comment"),
      },
      //社区评论头像
      {
        path: "/community/avatar",
        name: "community-avatar",
        component: () => import("@/pages/community/components/avatar"),
      },
    ],
  },
  //OJ
  {
    path: "/oj/index",
    name: "OJ",
    redirect: "/oj/questionBank",
    component: () => import("@/pages/OJ/index"),

    children: [
      {
        path: "/oj/questionBank",
        name: "questionBank",
        component: () => import("@/pages/OJ/questionBank"),
        meta: {
          activeMenu: "questionBank",
          keepAlive: true,
        },
      },
      {
        path: "/oj/questionBank/details",
        name: "questionBankDetails",
        component: () => import("@/pages/OJ/questionBank/details.vue"),
      },
      // TopicAnalysis
      {
        path: "/oj/questionBank/TopicAnalysis",
        name: "ojTopicAnalysis",
        component: () => import("@/pages/OJ/questionBank/TopicAnalysis.vue"),
        meta: {
          activeMenu: "questionBank",
        },
      },
      {
        path: "/oj/questionBank/MyquestionBank",
        name: "MyquestionBank",
        component: () => import("@/pages/OJ/questionBank/MyquestionBank.vue"),
        meta: {
          activeMenu: "questionBank",
        },
      },
      {
        path: "/oj/questionBank/addQuestion",
        name: "addQuestion",
        component: () => import("@/pages/OJ/questionBank/addQuestion.vue"),
        meta: {
          activeMenu: "questionBank",
        },
      },
      {
        path: "/oj/SubmitRecords",
        name: "SubmitRecords",
        component: () => import("@/pages/OJ/SubmitRecords/index.vue"),
        meta: {
          activeMenu: "questionBank",
        },
      },

      {
        path: "/oj/ListOfUestions",
        name: "ListOfUestions",
        component: () => import("@/pages/OJ/ListOfUestions"),
        meta: {
          activeMenu: "ListOfUestions",
          keepAlive: true,
        },
      },
      {
        path: "/oj/ListOfUestions/MyListOfUestions",
        name: "MyListOfUestions",
        component: () =>
          import("@/pages/OJ/ListOfUestions/MyListOfUestions.vue"),
        meta: {
          activeMenu: "ListOfUestions",
        },
      },
      {
        path: "/oj/ListOfUestions/ListOfUestionsList",
        name: "ListOfUestionsList",
        component: () =>
          import("@/pages/OJ/ListOfUestions/ListOfUestionsList.vue"),
        meta: {
          activeMenu: "ListOfUestions",
        },
      },
      {
        path: "/oj/teamStu",
        name: "teamStu",
        component: () => import("@/pages/OJ/teamStu/index.vue"),
        meta: {
          activeMenu: "teamStu",
        },
      },
      {
        path: "/oj/teamStu/details",
        name: "teamStyDetails",
        component: () => import("@/pages/OJ/teamStu/details.vue"),
        meta: {
          activeMenu: "teamStu",
          // keepAlive: true
        },
      },

      {
        path: "/oj/team",
        name: "team",
        component: () => import("@/pages/OJ/team/index.vue"),
        meta: {
          activeMenu: "team",
        },
      },
      {
        path: "/oj/team/teamListOfUestionsList",
        name: "teamListOfUestionsList",
        component: () => import("@/pages/OJ/team/teamListOfUestionsList.vue"),
        meta: {
          activeMenu: "team",
          // keepAlive: true
        },
      },
      {
        path: "/oj/team/details",
        name: "teamDetails",
        component: () => import("@/pages/OJ/team/details.vue"),
        meta: {
          activeMenu: "team",
        },
      },
      {
        path: "/oj/team/teamSubDetails",
        name: "teamSubDetails",
        component: () => import("@/pages/OJ/team/teamSubDetails.vue"),
        meta: {
          activeMenu: "team",
        },
      },
      {
        path: "/oj/recordOJ",
        name: "recordOJ",
        component: () => import("@/pages/OJ/recordOJ/index.vue"),
        meta: {
          activeMenu: "recordOJ",
        },
      },
      {
        path: "/oj/match",
        name: "match",
        component: () => import("@/pages/OJ/match/index.vue"),
        meta: {
          activeMenu: "match",
        },
      },

      {
        path: "/oj/match/addMatch",
        name: "addMatch",
        component: () => import("@/pages/OJ/match/addMatch.vue"),
        meta: {
          activeMenu: "match",
        },
      },
      {
        path: "/oj/match/addUser",
        name: "addUser",
        component: () => import("@/pages/OJ/match/addUser.vue"),
        meta: {
          activeMenu: "match",
        },
      },
      {
        path: "/oj/match/addMatchProblem",
        name: "addMatchProblem",
        component: () => import("@/pages/OJ/match/addMatchProblem.vue"),
        meta: {
          activeMenu: "match",
        },
      },
      {
        path: "/oj/match/matchAddQuestion",
        name: "matchAddQuestion",
        component: () => import("@/pages/OJ/match/matchAddQuestion.vue"),
        meta: {
          activeMenu: "match",
        },
      },
      {
        path: "/oj/match/detailsMatch",
        name: "detailsMatch",
        component: () => import("@/pages/OJ/match/detailsMatch.vue"),
        meta: {
          activeMenu: "match",
        },
      },
      {
        path: "/oj/match/matchDetails",
        name: "matchDetails",
        component: () => import("@/pages/OJ/match/details.vue"),
        meta: {
          activeMenu: "match",
        },
      },
      {
        path: "/oj/match/MyMatch",
        name: "MyMatch",
        component: () => import("@/pages/OJ/match/MyMatch.vue"),
        meta: {
          activeMenu: "match",
        },
      },

      {
        path: "/oj/ranking",
        name: "ranking",
        component: () => import("@/pages/OJ/ranking/index.vue"),
        meta: {
          activeMenu: "ranking",
        },
      },

      {
        path: "/oj/MyOj",
        name: "MyOj",
        component: () => import("@/pages/OJ/MyOj/index.vue"),
        meta: {
          activeMenu: "MyOj",
        },
      },

      {
        path: "/oj/MyOj/administration",
        name: "administration",
        component: () => import("@/pages/OJ/MyOj/administration.vue"),
        meta: {
          activeMenu: "MyOj",
        },
      },
      {
        path: "/oj/MyOj/addMyGame",
        name: "addMyGame",
        component: () => import("@/pages/OJ/MyOj/addMyGame.vue"),
        meta: {
          activeMenu: "MyOj",
        },
      },

      {
        path: "/oj/MyOj/MyOjProblem",
        name: "MyOjProblem",
        component: () => import("@/pages/OJ/MyOj/MyOjProblem.vue"),
        meta: {
          activeMenu: "MyOj",
        },
      },
    ],
  },
  //赛考中心
  {
    path: "/competition-center",
    name: "CompetitionCenter",
    redirect: "/competitionCenter/questionBankCenter",
    component: () => import("@/pages/competitionCenter/index"),
    meta: {
      keepAlive: false,
    },
    children: [
      //题库中心
      {
        path: "/competitionCenter/questionBankCenter",
        name: "CompetitionCenter-QuestionBankCenter",
        redirect: "/competitionCenter/questionBankCenter/platform",
        component: () => import("@/pages/competitionCenter/components/questionBankCenter"),
        meta: {
          keepAlive: false,
        },
        children: [
          { // 平台
            path: "platform",
            name: "CompetitionCenter-QuestionBankCenter-Platform",
            component: () => import("@/pages/competitionCenter/components/questionBankCenterPlatform"),
            meta: {
              keepAlive: false,
            },
            children: [
              // 题库中心-赛考训练-大赛详情
              {
                path: "/competitionCenter/questionBankCenter/matchDetail/:id",
                name: "CompetitionCenter-QuestionBankCenter-MatchDetail",
                component: () => import("@/pages/competitionCenter/components/matchDetail"),
                meta: {
                  keepAlive: false,
                },
              },
            ]
          },
          { // 校区
            path: "campus",
            name: "CompetitionCenter-QuestionBankCenter-Campus",
            component: () => import("@/pages/competitionCenter/components/questionBankCenterCampus"),
            meta: {
              keepAlive: false,
            },
          },
        ]
      },
      // // 题库中心-赛考训练-大赛详情
      // {
      //   path: "/competitionCenter/questionBankCenter/matchDetail/:id",
      //   name: "CompetitionCenter-QuestionBankCenter-MatchDetail",
      //   component: () => import("@/pages/competitionCenter/components/matchDetail"),
      //   meta: {
      //     keepAlive: true,
      //   },
      // },
      // 试卷中心
      {
        path: "/competitionCenter/testPaperCenter",
        name: "CompetitionCenter-TestPaperCenter",
        component: () => import("@/pages/competitionCenter/components/testPaperCenter"),
        meta: {
          keepAlive: false,
        },
      },
      // 练习/考试
      {
        path: "/competitionCenter/practiceAndExams",
        name: "CompetitionCenter-PracticeAndExams",
        component: () => import("@/pages/competitionCenter/components/practiceAndExams"),
        meta: {
          keepAlive: false,
        },
      },
      // 发起考试
      // {
      //   path: "/competitionCenter/initiateExam",
      //   name: "CompetitionCenter-InitiateExam",
      //   component: () => import("@/pages/competitionCenter/components/initiateExam"),
      //   meta: {
      //     keepAlive: true,
      //   },
      // },
      // 发起考试
      {
        path: "/competitionCenter/commonExam/exam-index",
        name: "CommonExam-ExamIndex",
        component: () => import("@/pages/competitionCenter/components/commonExam/exam-index"),
        meta: {
          activeMenu: "exam-index",
        },
      },
      {
        path: "/competitionCenter/commonExam/own-question",
        name: "CommonExam-OwnQuestion",
        // name: "own-question",
        component: () => import("@/pages/competitionCenter/components/commonExam/own-question"),
        meta: {
          activeMenu: "own-question",
          keepAlive: false,
        },
      },
      {
        path: "/competitionCenter/commonExam/add-question",
        name: "CommonExam-AddQuestion",
        component: () => import("@/pages/competitionCenter/components/commonExam/add-question"),
        meta: {
          activeMenu: "own-question",
        },
      },
      {
        path: "/competitionCenter/commonExam/questionlist",
        name: "CommonExam-Questionlist",
        component: () => import("@/pages/competitionCenter/components/commonExam/questionlist"),
        meta: {
          activeMenu: "own-question",
        },
      },
      {
        path: "/competitionCenter/commonExam/questionlist1",
        name: "CommonExam-Questionlist1",
        component: () => import("@/pages/competitionCenter/components/commonExam/questionlist1"),
        meta: {
          activeMenu: "own-question",
        },
      },

      {
        path: "/competitionCenter/commonExam/platform-questionlist",
        name: "CommonExam-PlatformQuestionlist",
        component: () =>
          import("@/pages/competitionCenter/components/commonExam/platform-questionlist"),
        meta: {
          activeMenu: "platform-question",
        },
      },

      {
        path: "/competitionCenter/commonExam/platform-questionlist1",
        name: "CommonExam-PlatformQuestionlist1",
        component: () =>
          import("@/pages/competitionCenter/components/commonExam/platform-questionlist1"),
        meta: {
          activeMenu: "platform-question",
        },
      },

      {
        path: "/competitionCenter/commonExam/practice",
        name: "CommonExam-Practice",
        component: () => import("@/pages/competitionCenter/components/commonExam/practice"),
        meta: {
          activeMenu: "own-question",
        },
      },
      {
        path: "/competitionCenter/commonExam/sequence",
        name: "CommonExam-Sequence",
        component: () => import("@/pages/competitionCenter/components/commonExam/sequence"),
        meta: {
          activeMenu: "own-question",
        },
      },
      {
        path: "/competitionCenter/commonExam/create-exam",
        name: "CommonExam-CreateExam",
        component: () => import("@/pages/competitionCenter/components/commonExam/create-exam"),
        meta: {
          activeMenu: "exam-management",
        },
      },

      {
        path: "/competitionCenter/commonExam/create-paper",
        name: "CommonExam-CreatePaper",
        component: () => import("@/pages/competitionCenter/components/commonExam/create-paper"),
        meta: {
          activeMenu: "paper-management",
        },
      },
      {
        // path: "/paper/edit-questions",
        path: "/competitionCenter/commonExam/edit-questions",
        name: "CommonExam-EditQuestions",
        component: () => import("@/pages/competitionCenter/components/commonExam/edit-questions"),
        meta: {
          activeMenu: "paper-management",
        },
      },
      {
        // path: "/paper/edit-exam",
        path: "/competitionCenter/commonExam/edit-exam",
        name: "CommonExam-EditExam",
        component: () => import("@/pages/competitionCenter/components/commonExam/edit-exam"),
        meta: {
          activeMenu: "exam-management",
        },
      },

      {
        // path: "/paper/start-exam",
        path: "/competitionCenter/commonExam/start-exam",
        name: "CommonExam-StartExam",
        component: () => import("@/pages/competitionCenter/components/commonExam/start-exam"),
        meta: {
          activeMenu: "paper-management",
        },
      },

      {
        path: "/competitionCenter/commonExam/practice-management",
        name: "CommonExam-PracticeManagement",
        component: () => import("@/pages/competitionCenter/components/commonExam/practice-management"),
        meta: {
          activeMenu: "practice-management",
          keepAlive: false,
        },
      },
      {
        path: "/competitionCenter/commonExam/create-practice",
        name: "CommonExam-CreatePractice",
        component: () => import("@/pages/competitionCenter/components/commonExam/create-practice"),
        meta: {
          activeMenu: "practice-management",
        },
      },
      {
        path: "/competitionCenter/commonExam/edit-practice",
        name: "CommonExam-EditPractice",
        component: () => import("@/pages/competitionCenter/components/commonExam/edit-practice"),
        meta: {
          activeMenu: "practice-management",
        },
      },

      {
        path: "/competitionCenter/commonExam/platform-question",
        name: "CommonExam-PlatformQuestion",
        component: () => import("@/pages/competitionCenter/components/commonExam/platform-question"),
        meta: {
          activeMenu: "platform-question",
          keepAlive: true,
        },
      },
      {
        path: "/competitionCenter/commonExam/exam-management",
        name: "CommonExam-ExamManagement",
        component: () => import("@/pages/competitionCenter/components/commonExam/exam-management"),
        meta: {
          activeMenu: "exam-management",
        },
      },

      {
        path: "/competitionCenter/commonExam/edit-examstu",
        name: "CommonExam-EditExamstu",
        component: () => import("@/pages/competitionCenter/components/commonExam/edit-examstu"),
        meta: {
          activeMenu: "exam-management",
        },
      },

      {
        path: "/competitionCenter/commonExam/edit-practicestu",
        name: "CommonExam-EditPracticestu",
        component: () => import("@/pages/competitionCenter/components/commonExam/edit-practicestu"),
        meta: {
          activeMenu: "practice-management",
        },
      },

      {
        path: "/competitionCenter/commonExam/exam-result",
        name: "CommonExam-ExamResult",
        component: () => import("@/pages/competitionCenter/components/commonExam/exam-result"),
        meta: {
          activeMenu: "exam-management",
        },
      },

      {
        path: "/competitionCenter/commonExam/practice-result",
        name: "CommonExam-PracticeResult",
        component: () => import("@/pages/competitionCenter/components/commonExam/practice-result"),
        meta: {
          activeMenu: "practice-management",
        },
      },
      {
        path: "/competitionCenter/commonExam/correct-practice1",
        name: "CommonExam-CorrectPractice1",
        component: () => import("@/pages/competitionCenter/components/commonExam/correct-practice1"),
        meta: {
          activeMenu: "practice-management",
        },
      },

      {
        path: "/competitionCenter/commonExam/paper-management",
        name: "CommonExam-PaperManagement",
        component: () => import("@/pages/competitionCenter/components/commonExam/paper-management"),
        meta: {
          activeMenu: "paper-management",
        },
      },
      {
        path: "/competitionCenter/commonExam/offline-exam",
        name: "CommonExam-OfflineExam",
        component: () => import("@/pages/competitionCenter/components/commonExam/offline-exam"),
        meta: {
          activeMenu: "paper-management",
        },
      },
      {
        path: "/competitionCenter/commonExam/practice-detail",
        name: "CommonExam-PracticeDetail",
        component: () => import("@/pages/competitionCenter/components/commonExam/practice-detail"),
        meta: {
          activeMenu: "practice-management",
        },
      },
      //试卷预览
      {
        path: "/competitionCenter/commonExam/paper-detail",
        name: "CommonExam-PaperDetail",
        component: () => import("@/pages/competitionCenter/components/commonExam/paper-detail"),
      },
      {
        path: "/competitionCenter/commonExam/correct-exam",
        name: "CommonExam-CorrectExam",
        component: () => import("@/pages/competitionCenter/components/commonExam/correct-exam"),
        meta: {
          activeMenu: "exam-management",
        },
      },
      //查看练习提交
      {
        path: "/competitionCenter/commonExam/correct-practice",
        name: "CommonExam-CorrectPractice",
        component: () => import("@/pages/competitionCenter/components/commonExam/correct-practice"),
        meta: {
          activeMenu: "practice-management",
        },
      },
    ],
  },
];

const routes = [
  {
    path: "/",
    name: "index",
    redirect: "/",
    component: () => import("@/pages/default"),
    children: routerList,
  },
  {
    path: "/code-classroom/video",
    name: "video",
    component: () =>
      import("@/pages/code-classroom/classroom-management/student/video.vue"),
    meta: {
      activeMenu: "classlistIndexStu1",
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/login"),
  },
  //python助手
  {
    path: "/s-link",
    name: "s-link",
    component: () => import("@/pages/s-link"),
  },
  {
    path: "/background",
    name: "background",
    redirect: "/background",
    component: () => import("@/pages/admin/default"),
    children: adminRouterList,
  },
  {
    path: "/background/login",
    name: "background/login",
    component: () => import("@/pages/admin/login"),
  },
  //手机端欢迎页面
  {
    path: "/m_index",
    name: "m_index",
    component: () => import("@/pages/default/m_index"),
  },
  // 驾校通
  {
    path: "/homeSchoolConnection",
    name: "homeSchoolConnection",
    component: () => import("@/pages/default/homeSchoolConnection"),
  },
  // 微信小程序的webview 作品详情
  {
    path: "/MiniWorksDetails",
    name: "MiniWorksDetails",
    component: () => import("@/pages/miniView/MiniWorksDetails"),
  },
  //PYTHON 编辑器
  {
    path: "/python/editor",
    name: "python_editor",
    component: () => import("@/pages/python-editor/index"),
  },

  //PYTHON 编辑器v2
  {
    path: "/python/editor_v2",
    name: "python_editor_v2",
    component: () => import("@/pages/python-editor/index_v2"),
  },
  //C++ 编辑器
  {
    path: "/cpp/editor",
    name: "cpp_editor",
    component: () => import("@/pages/cpp_editor/index"),
  },

  //PYTHON 上课
  {
    path: "/python/course",
    name: "python_course",
    component: () => import("@/pages/python-editor/course"),
  },

  //PYTHON 上课v2
  {
    path: "/python/course_v2",
    name: "python_course_v2",
    component: () => import("@/pages/python-editor/course_v2"),
  },

  //PYTHON 模拟测评v2
  {
    path: "/python/exam_v2",
    name: "python_exam_v2",
    component: () => import("@/pages/python-editor/exam_v2"),
  },

  //PYTHON 老师授课专用
  {
    path: "/python/teachpy",
    name: "teachpy",
    component: () => import("@/pages/python-editor/teach"),
  },
  //PYthon 教师授课专用v2版本
  {
    path: "/python/teachpy_v2",
    name: "teachpy_v2",
    component: () => import("@/pages/python-editor/teach_v2"),
  },
  {
    path: "/cpp",
    name: "lessonsDetails",
    component: () => import("@/pages/teach-lessons/details"),
  },
  {
    path: "/shareRanking",
    name: "shareRanking",
    component: () => import("@/pages/OJ/shareRanking/index.vue"),
  },
  {
    path: "/MyMatchRanking",
    name: "MyMatchRanking",
    component: () => import("@/pages/OJ/match/MyMatchRanking.vue"),
  },
  {
    path: "/cpp/stu",
    name: "cppStu",
    component: () => import("@/pages/teach-lessons/StuDetails"),
    meta: {
      // activeMenu: "classlistIndexTeacher",
    },
  },

  //学生考试
  {
    path: "/exam-stu/new-exam",
    name: "new-exam",
    component: () => import("@/pages/exam-stu/components/new-exam"),
  },

  //试卷预览
  {
    path: "/exam/paper-detail",
    name: "paper-detail",
    component: () => import("@/pages/exam/components/paper-detail"),
  },


  //练习预览
  {
    path: "/exam/practice-detail",
    name: "practice-detail",
    component: () => import("@/pages/exam/components/practice-detail"),
  },


  //学生练习
  {
    path: "/exam-stu/new-practice",
    name: "new-practice",
    component: () => import("@/pages/exam-stu/components/new-practice"),
  },

  {
    path: "/exam/correct-exam",
    name: "correct-exam",
    component: () => import("@/pages/exam/components/correct-exam"),
    meta: {
      activeMenu: "exam-management",
    },
  },

  //查看练习提交
  {
    path: "/exam/correct-practice",
    name: "correct-practice",
    component: () => import("@/pages/exam/components/correct-practice"),
    meta: {
      activeMenu: "practice-management",
    },
  },
  {
    path: "/exam-stu/practice-record",
    name: "practice-record",
    component: () => import("@/pages/exam-stu/components/practice-record"),
  },

  //社区-作品详情
  {
    path: "/community/project",
    name: "community-project",
    component: () => import("@/pages/community/components/project"),
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});


// 解决重复点击菜单报错的问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
